import { render, staticRenderFns } from "./AppRadioButton.vue?vue&type=template&id=4544e2a7&scoped=true&"
import script from "./AppRadioButton.vue?vue&type=script&lang=js&"
export * from "./AppRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./AppRadioButton.vue?vue&type=style&index=0&id=4544e2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544e2a7",
  null
  
)

export default component.exports